import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

import { ProjectSchemaType } from '@/app/org-cfv/src/typings/CreateProjectTypings';
import { CustomStateCreator } from '@/typings/zustand';
import { isEnabledReduxDevTool } from '@/utils/common';
import { immer } from '@/zustand/middlewares/immer';

interface PageSlice {
  project?: ProjectSchemaType;
}

type CombinedSlice = PageSlice;

const createPageSlice: CustomStateCreator<CombinedSlice, PageSlice> = () => ({});

export const useProjectStore = create<CombinedSlice>()(
  immer(
    devtools(
      subscribeWithSelector((...a) => ({ ...createPageSlice(...a) })),
      { enabled: isEnabledReduxDevTool, name: 'useProjectStore' },
    ),
  ),
);
